<template>
  <section class="hero">
    <div class="container">
      <div class="row">
        <div class="col-1 hidden-sm"></div>
        <div class="col-6 side lft">
          <Gallery
            :images="$props.images"
            :card="false"
            @track="$props.track"
          />
        </div>
          <div class="col-4 side rgt">
            <div class="content rel" :class="{'open': open}">
              <h1 class="park-title" @mouseup="setHightlightTooltip()">{{ $props.park.name }}</h1>
               <p class="tip pill pill--lrg" :class="{ active: showTooltip }">
                  Don't forget, we guarantee you won't find a cheaper price elsewhere
              </p>
              <div class="crumb">
                <a :href="goToPlace($props.park.region, parksUrl)" class="clnk">{{ $props.park.region }}</a>
                <a :href="goToPlace($props.park.location, searchUrl)" class="clnk">{{ $props.park.location }}</a>
              </div>
              <p v-if="lowerPrice !== 0 && $props.park.price_range !== ''" class="park-pricing">Weekly prices from: {{ lowerPrice | money }} - {{ upperPrice | money }}</p>
              <p v-else-if="$props.park.price_range !== ''" class="park-pricing">Weekly prices up to {{ upperPrice | money}} </p>
              <p class="park-info" v-html="$props.park.description"></p>
              <div class="btn-container">
                <p v-if="!$props.isMobile && showReadMore" class="read-more" :class="{'open': open}" @click="readMore()">Read
                  <span v-if="!open">more</span>
                  <span v-else>less</span>
                </p>
                <button class="view-acc" @click="goToSection()">View accommodation</button>
              </div>
            </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Gallery from '../shared/gallery.vue'
import OrganicSearchForm from '../shared/organicSearchForm.vue'

export default {
  data: function () {
    return {
      open: false,
      lowerPrice: '',
      upperPrice: '',
      showTooltip: false,
      showReadMore: true,
      searchUrl: "/searches/custom?search[region]=",
      parksUrl: "/holiday-parks/",
      isExternal: document.referrer.indexOf('snaptrip') === -1
    }
  },
  props: {
      value: String,
      properties: Array,
      park: Object,
      images: Array,
      activeTab: String,
      track: Function,
      isMobile: Boolean
  },  
  components: {
      Gallery, OrganicSearchForm
  },
  filters: {
    money: function money(val) {
      if (typeof val !== "undefined" && val !== "" && val !== null) {
        if (window.Intl) {
          let dec = parseFloat(val) % 1 === 0 ? 0 : 2;
            return new Intl.NumberFormat('en-GB', {
              style: 'currency',
              currency: 'GBP',
              maximumFractionDigitsDigits: dec,
              minimumFractionDigits: dec
            }).format(val);
        } else {
          return "£" + val;
        }
      }
    } 
  },
  methods: {
    readMore: function() {
      this.$emit('track', "read_more_click");
      this.open = !this.open
    },
    goToPlace: function(val, url) {
      return url + (val.indexOf("Nr") > -1 ? val.split("Nr")[1].trim() : val);
    },
    goToSection: function() {
      let body = document.body;
      let filter = body.querySelector("#filters"),
          date = document.querySelector("#filters #date");

      this.$emit('track', "view_accomadation_button_click");

      if (this.$props.activeTab !== 'mobile'){
        this.$emit('toggleTabs', 'filters');
      }

      setTimeout(() => {
        window.scrollTo({
            top: filter.getBoundingClientRect().top,
            behavior: "smooth"
        });
      }, 50);

      setTimeout(() => {
           date.click();
      }, 250);
    },
    formatPrice: function() {
      let range = this.$props.park.price_range,
          pricesArr;

      if (range !== "") {
          pricesArr = range.split('-');
          this.lowerPrice = parseInt(pricesArr[0].replace('£',''));
          this.upperPrice = parseInt(pricesArr[1].replace('£',''));
      }
    },
    setHightlightTooltip: function() {
       if(window.getSelection().type === 'Range'){   
            this.showTooltip = true;
       }
    },
    hideToolTip: function(){
        this.showTooltip = false;
    }
  },
  mounted: function() {
    this.formatPrice();
    this.showReadMore = document.querySelector('.content.rel').clientHeight >= 480;
    window.addEventListener('mousedown', this.hideToolTip);
  }
}
</script>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.testA {
  display: none;
}

.hero {
  display: flex;
  flex-direction: column;
  justify-content: center;

  .isIE & {
    display: block;
  }
}

.side {
  box-sizing: border-box;

  &.rgt {
    padding: 1.25rem;

    p:empty {
      display: none;
    }
  }
}

.crumb {
  margin-top: .313rem;
  position: relative;
}

.clnk {
  font-weight: 700;
  color: $col_lgrey;
  text-transform: uppercase;
  text-decoration: none;
  padding-right: .5rem;
  position: relative;
  font-size: .75rem;
  transition: color 0.2s ease-in-out;
  cursor: pointer;

  &:after {
    content: "";
    position: absolute;
    height: 70%;
    top: 15%;
    right: 0.0625rem;
    background: $col_lgrey;
    width: 0.0625rem;
  }

  &:last-of-type:after {
    display: none;
  }

  &:hover {
    color: $col_orange;
  }
}

.content.rel {
  position: relative;
}

.park {
   &-title {
     font-size: 1.25rem;
     font-weight: 700;
   }
      
   &-pricing {
     padding: 1.5rem 0 0 0;
     color: $col_orange; 
     font-weight: 700;
   }

   &-info {
     display: none;
     white-space: pre-wrap;

     ul {
       margin: 1rem;
     }
  }

  &-info, &-pricing {
    font-size: .875rem;
    line-height: 1.2;
  }
}

.btn-container {
  position: relative;
  bottom: 0;
  width: 100%;
}

.view-acc {
  width: 100%;
  color: $col_white;
  background: $col_orange;
  font-weight: 700;
  height: 2.5rem;
  padding: 0 1.25rem;
  font-size: .875rem;
  border-radius: .3rem;
  box-shadow: 0 .125rem .25rem $col_oplightblack;
  margin: 1.5rem 0 0;
  cursor: pointer;
  outline: none;

  &:focus {
    box-shadow: 0 0.125rem 1.25rem 0 $col_aqua;
  }
}

.tip {
  display: none;
}

.read-more {
  background: $col_xlgrey;
  color: $col_orange;
  font-weight: 700;
  position: relative;
  width: 7.5rem;
  text-align: left;
  font-size: .875rem;
  padding: 1rem 0;
  width: 100%;
  display: none;
  cursor: pointer;

  span {
    color: $col_orange;
  }

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    margin-left: 0.5rem;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    border-left: .375rem solid transparent;
    border-right: .375rem solid transparent;
    border-top: .375rem solid $col_orange;
  }

  &.open:after {
    border-bottom: .375rem solid $col_orange;
    border-top: none;
  }
}

.row.search-form {
    padding: 1.25rem;
    box-sizing: border-box;
}
.search_title {
  font-size: 1.25rem;
}
.search_sub {
  font-weight: 400;
}

@media #{$desktop} {

  .row.search-form {
    padding: 1.25rem 0;
  }

  .hero {
    flex-direction: row;
    overflow: hidden;
    margin-bottom: 1.25rem;
  }

  .side {
    box-sizing: border-box;
    
    &.lft {
      padding-left: 1.25rem;
    }

    &.rgt {
      padding: 0 2.5rem;
    }
  }

  .content {
    max-height: 30rem;
    overflow: hidden;
    transition: all 0.5s ease;


    &.open {
      max-height: 100rem;
    }
  }

  .park {

    &-title {
      font-size: 1.875rem;

      &::selection {
      background-color: $col_orange;
      color: $col_white;
      }
    }

    &-info {
      display:block;
      padding: 2rem 0 6.5rem;
    }

    &-location {
      padding: 1rem 0 0 0;
      border-bottom: none;
    }
  }

  .view-acc {
    margin: 0;
  }

  .btn-container {
    position: absolute;
    box-shadow: 0px 0px 20px 10px rgb(246, 246, 246);
  }

  .read-more {
    display: block;
  }

  //tooltip

  .tip {
    display: block;
    position: absolute;
    z-index: 1;
    width: 86%;
    left: 50%;
    top: 8rem;
    text-align: center; 
    transform: translate(-50%);
    opacity: 0;
    height:0;
    border:none;
    font-weight: normal;
    transition: opacity 0.3s 0.1s ease-out, top 0.3s 0.1s ease-out;
    background-color: $col_purple;
    margin: .63rem auto;
    padding: .63rem 1.25rem;
    box-sizing: border-box;
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, 0.5);
    color: $col_white;
    outline: 0;
    border-radius: 4rem;

    &.active {
      padding: 0.8rem;
      height: auto;
      opacity: 1;
      top: 6rem;  
      z-index: 100;

      &:before {
        content: '';
        width: 0;
        height: 0;
        border-style: solid;
        border-color: transparent transparent #424F98;
        border-width: 0 1rem 1rem;
        position: absolute;
        top: -1rem;
        left: 3.5rem;
      }
    }

  }


}
</style>